<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >

    <material-card
      icon="mdi-clipboard-text"
      icon-small
      title="Всі передзамовлення"
      color="accent"
    >
      <v-row class="mx-2 mb-2">
        <v-col cols="12" md="3">
          <v-select
            return-object
            item-text="name"
            item-value="name"
            v-model="project"
            :items="projects"
            label="Проект"
            clearable
          ></v-select>
        </v-col>
      </v-row>
      
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">
              ID та дата
            </th>
            <th class="primary--text">
              Проект
            </th>
            <th class="primary--text">
              Товар
            </th>
            <th class="primary--text">
              Кількість
            </th>
            <th class="primary--text">
              Сума
            </th>
            <th class="primary--text">
              Тип доставки
            </th>
            <th class="primary--text">
              Місто
            </th>
            <th class="primary--text">
              Покупець
            </th>
            <th class="primary--text">
              Коментар
            </th>
            <th v-if="isAdmin" width="50"></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(order, index) in preorders" :key="`order-${index}`" @dblclick="toPreorderProfil(order.id)">
            <td><span class="font-weight-medium">
              {{ order.id || '-' }}</span> <br> {{ order.date | formatDate }}
              <span class="table-marker default"></span>
            </td>
            <td class="one-line">{{ order.project_name || '-' }}</td>
            <td>{{ order.product_name || '-' }}</td>
            <td>{{ order.quantity || '-' }}</td>
            <td class="one-line"> <span v-if="order.price">{{ order.price * order.quantity | numFormat }} грн</span></td>
            <td>{{ order.delivery_name || '-' }}</td>
            <td class="one-line">{{ order.city_name || '-' }}</td>
            <td><span class="font-weight-medium">{{ order.full_name || '-' }}</span> <br/> {{ order.phone || '-' }}  </td>
            <td>{{ order.comment || '-' }}</td>
            <td v-if="isAdmin">
              <span class="d-flex">
                <v-icon
                  class="mr-4"
                  color="green"
                  @click="toPreorderProfil(order.id)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  color="error"
                  @click="onDialog(order.id)"
                >
                  mdi-delete
                </v-icon>
              </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <div v-if="preorders.length && totalCount > pageSize" class="text-center py-4">
        <v-pagination
          v-model="currentPage"
          :total-visible="9"
          :length="pageLength"
        ></v-pagination>
      </div>
    </material-card>

    <v-dialog
      v-model="dialog"
      max-width="400">
      <v-card>
        <v-card-title class="text-h5 align-center">
          Ви дійсно хочете видалити?
        </v-card-title>
        <v-card-actions class="flex justify-center">
          <v-btn
            color="primary" 
            min-width="150"
            text
            @click="onRemovePreOrder"
          >
            Так
          </v-btn>
          <v-btn
            color="grey"
            min-width="150"
            text
            @click="closeDialog"
          >
            Нi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { HTTP } from '../http-common';
import { mapGetters,  mapMutations, mapActions } from 'vuex'

  export default {
    name: 'RegularTablesView',
    data() {
      return {
        preorders: [],
        project: {},
        currentPage: 1,
        pageSize: 10,
        totalCount: null,
        preorderId: null,
        dialog: false,
        projects: []
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'snackbar', 'projects']),
      pageLength() {
        if (this.totalCount) {
          return Math.round(this.totalCount / this.pageSize)
        }
      }
    },
    methods: {
      ...mapMutations(['setSnackbar']),
      ...mapActions(['getStatus']),
      getPreorders() {
        HTTP.post('/get-preorders', {
          project_id: this.project && this.project.id || null,
          limit: this.pageSize,
          page: this.currentPage
        })
          .then(({ data }) => {
            if (data.content) {
              this.preorders = data.content.data
              this.totalCount = data.content.total_count || null
            }
          })
      },
      getProjects() {
        HTTP.post('/get-projects', {
          user_use: true
        })
          .then(response => {
            if (response.data && response.data.content) {
              this.projects = response.data.content
            }
          })
          .catch(error => {
              console.log(error);
          })
      },
      onDialog(id) {
        this.dialog = true
        this.preorderId = id
      },
      closeDialog() {
        this.dialog = false 
        this.preorderId = null
      },
      onRemovePreOrder() {
        this.dialog = false
        if (this.isAdmin) {
          HTTP.post('/delete-preorder', {
            'id': this.preorderId
          })
            .then(() => {
              this.setSnackbar({ type: 'success', text: 'Успiшно видалено' });
              this.getPreorders();
            })
            .catch((error) => {
              this.setSnackbar({ type: 'error', text: error.message });
            })
          }
      },
      toPreorderProfil(id) {
        this.$router.push(`/preorders/${id}`);
      },
      scrollToTop() {
        window.scrollTo({
          top: 120,
          behavior: 'smooth'
        })
      },
      setFilters() {
        if(this.$route.query.page) {
          this.currentPage = Number(this.$route.query.page);
        }
        if(this.$route.query.project) {
          this.project = this.projects.find(el => el.id == this.$route.query.project)
        }
      },
      pushQuery() {
        let data = {};

        if (this.currentPage > 1) {
          data.page = this.currentPage;
        }
        if (this.project && this.project.id) {
          data.project = this.project.id;
        }

        this.$router.push({
          query: data
        })
      }
    },
    watch: {
      project() {
        this.pushQuery();
        this.getPreorders();
      },
      currentPage() {
        this.pushQuery();
        this.getPreorders();
        this.scrollToTop();
      }
    },
    mounted() {
      this.setFilters();
      this.getProjects();
      this.getStatus();
      this.getPreorders();
    }
  }

</script>
